module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "formulario-de-solicitacao"
    }
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('alerta', {
    attrs: {
      "tipo": 'erro',
      "texto": _vm.mensagemDeErro
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.cadastrarSolicitacao.apply(null, arguments)
      }
    }
  }, [_c('h2', {
    staticClass: "titulo titulo_grande"
  }, [_vm._v("\n        Preencha todos os campos obrigatórios abaixo para solicitar o\n        subsídio.\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [(_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Renda total apurada")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.solicitacao.RendaTotalComprovada))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Renda familiar cadastrada")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.somatorioDaRenda))])])]), _vm._v(" "), _vm._l((_vm.solicitacao.Proponentes), function(proponente, index) {
    return _c('div', [_c('div', {
      staticClass: "grade__linha"
    }, [_c('div', {
      staticClass: "grade__coluna grade__coluna_5"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v(_vm._s(index + 1) + "º Proponente")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "grade__coluna grade__coluna_3"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v("CPF")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "grade__coluna grade__coluna_2"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v("Telefone")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Telefone || "Não informado"))])]), _vm._v(" "), (!_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
      staticClass: "grade__coluna grade__coluna_2"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v("Renda")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatarMonetario(proponente.Renda)))])]) : _vm._e()]), _vm._v(" "), (proponente.Conjuge) ? _c('div', {
      staticClass: "grade__linha"
    }, [_c('div', {
      staticClass: "grade__coluna grade__coluna_5"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v("Cônjuge (" + _vm._s(index + 1) + "º Proponente)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "grade__coluna grade__coluna_3"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v("CPF")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "grade__coluna grade__coluna_2"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v("Telefone")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Telefone || "Não informado"))])]), _vm._v(" "), (!_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
      staticClass: "grade__coluna grade__coluna_2"
    }, [_c('label', {
      staticClass: "formulario__label"
    }, [_vm._v("Renda")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatarMonetario(proponente.Conjuge.Renda)))])]) : _vm._e()]) : _vm._e()])
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('span', [_vm._v(_vm._s(this.cidade.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Empreendimento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.EmpreendimentoId),
      expression: "solicitacao.EmpreendimentoId"
    }],
    staticClass: "formulario__input",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.solicitacao, "EmpreendimentoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.empreendimentos), function(empreendimento) {
    return _c('option', {
      domProps: {
        "value": empreendimento.Id,
        "selected": empreendimento.Id === _vm.solicitacao.EmpreendimentoId ?
          'selected' :
          ''
      }
    }, [_vm._v("\n                " + _vm._s(empreendimento.Nome) + "\n              ")])
  }), 0)]), _vm._v(" "), (_vm.ehEmpreendimentoDeCasaEApartamento()) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Tipo do imóvel")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.TipoDeImovel),
      expression: "solicitacao.TipoDeImovel"
    }],
    staticClass: "formulario__input",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.solicitacao, "TipoDeImovel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tiposDeImovel), function(tipoDeImovel) {
    return _c('option', {
      domProps: {
        "value": tipoDeImovel.Id,
        "selected": tipoDeImovel.Id === _vm.solicitacao.TipoDeImovel ?
          'selected' :
          ''
      }
    }, [_vm._v("\n                " + _vm._s(tipoDeImovel.Nome) + "\n              ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.empreendimentoEstaSelecionado()) ? _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_5"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Construtora")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Nome))])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Cnpj))])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Conta")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Conta))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Cep),
      expression: "solicitacao.Cep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99999-999'),
      expression: "'99999-999'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "cep",
      "type": "tel",
      "id": "cep",
      "placeholder": "Somente números",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Cep", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "tipo-do-logradouro"
    }
  }, [_vm._v("Tipo do logradouro")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.TipoDeLogradouroId),
      expression: "solicitacao.TipoDeLogradouroId"
    }],
    staticClass: "formulario__input",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.solicitacao, "TipoDeLogradouroId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tiposDeLogradouro), function(tipoDeLogradouro) {
    return _c('option', {
      domProps: {
        "value": tipoDeLogradouro.Id,
        "selected": tipoDeLogradouro.Id === _vm.solicitacao.TipoDeLogradouroId ?
          'selected' :
          ''
      }
    }, [_vm._v("\n                " + _vm._s(tipoDeLogradouro.Nome) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_5"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "logradouro"
    }
  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Logradouro),
      expression: "solicitacao.Logradouro"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "logradouro",
      "type": "text",
      "maxlenght": "90",
      "name": "logradouro",
      "placeholder": "Ex: Afonso Pena, da Divisão, Lídia Baís, etc.",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Logradouro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Logradouro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "numero"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Numero),
      expression: "solicitacao.Numero"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "numero",
      "type": "number",
      "placeholder": "EX: 481",
      "number": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "bairro"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Bairro),
      expression: "solicitacao.Bairro"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "bairro",
      "name": "bairro",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: Centro, Santa Fé, Vila Carvalho...",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Bairro", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.empreendimentoEstaSelecionado()) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_1"
  }, [(_vm.ehEmpreendimentoDeApartamento()) ? _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "bloco"
    }
  }, [_vm._v("Bloco\n              ")]) : _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "quadra"
    }
  }, [_vm._v("Quadra/Bloco\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.BlocoOuQuadra),
      expression: "solicitacao.BlocoOuQuadra"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "quadra",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: 1",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.BlocoOuQuadra)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "BlocoOuQuadra", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.empreendimentoEstaSelecionado()) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [(_vm.ehEmpreendimentoDeApartamento()) ? _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "apartamento"
    }
  }, [_vm._v("Apartamento\n              ")]) : _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "lote"
    }
  }, [_vm._v("Lote/Apartamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ApartamentoOuLote),
      expression: "solicitacao.ApartamentoOuLote"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "lote",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: A",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ApartamentoOuLote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ApartamentoOuLote", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Complemento),
      expression: "solicitacao.Complemento"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "complemento",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: casa 2"
    },
    domProps: {
      "value": (_vm.solicitacao.Complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Complemento", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ValorDaCompraEVenda),
      expression: "solicitacao.ValorDaCompraEVenda"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "valor-da-compra-e-venda",
      "type": "text",
      "placeholder": "130.000,00",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ValorDaCompraEVenda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ValorDaCompraEVenda", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-de-avaliacao"
    }
  }, [_vm._v("Valor de avaliação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ValorDeAvaliacao),
      expression: "solicitacao.ValorDeAvaliacao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "valor-de-avaliacao",
      "type": "text",
      "placeholder": "130.000,00",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ValorDeAvaliacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ValorDeAvaliacao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-do-financiamento-aprovado"
    }
  }, [_vm._v("Valor do financiamento concedido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ValorDoFinanciamentoAprovado),
      expression: "solicitacao.ValorDoFinanciamentoAprovado"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "valor-do-financiamento-aprovado",
      "type": "text",
      "placeholder": "90.000,00",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ValorDoFinanciamentoAprovado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ValorDoFinanciamentoAprovado", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "subsidio-governo-federal"
    }
  }, [_vm._v("Subsídio Governo Federal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.SubsidioDoGovernoFederal),
      expression: "solicitacao.SubsidioDoGovernoFederal"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "subsidio-governo-federal",
      "type": "text",
      "placeholder": "14.000,00"
    },
    domProps: {
      "value": (_vm.solicitacao.SubsidioDoGovernoFederal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "SubsidioDoGovernoFederal", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "codigo-de-avaliacao"
    }
  }, [_vm._v("Código de avaliação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.CodigoDeAvaliacao),
      expression: "solicitacao.CodigoDeAvaliacao"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "codigo-de-avaliacao",
      "type": "number",
      "placeholder": "Somente números",
      "number": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.CodigoDeAvaliacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "CodigoDeAvaliacao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "data-de-avaliacao"
    }
  }, [_vm._v("Data de avaliação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.DataDeAvaliacao),
      expression: "solicitacao.DataDeAvaliacao"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "data-de-avaliacao",
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.DataDeAvaliacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "DataDeAvaliacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [(_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "desconto-da-construtora"
    }
  }, [_vm._v("Desconto da construtora na entrada\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.DescontoConstrutora),
      expression: "solicitacao.DescontoConstrutora"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "desconto-da-construtora",
      "type": "text",
      "placeholder": "10.000,00"
    },
    domProps: {
      "value": (_vm.solicitacao.DescontoConstrutora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "DescontoConstrutora", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "participacao-necessaria"
    }
  }, [_vm._v("Participação do proponente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ParticipacaoDoSolicitante),
      expression: "solicitacao.ParticipacaoDoSolicitante"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "participacao-necessaria",
      "type": "text",
      "placeholder": "10.000,00"
    },
    domProps: {
      "value": (_vm.solicitacao.ParticipacaoDoSolicitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ParticipacaoDoSolicitante", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "subsidio-solicitado-agehab"
    }
  }, [_vm._v("Subsídio solicitado AGEHAB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.SubsidioDaAgehab),
      expression: "solicitacao.SubsidioDaAgehab"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "subsidio-solicitado-agehab",
      "type": "text",
      "placeholder": "6.000,00",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.SubsidioDaAgehab)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "SubsidioDaAgehab", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.FgtsDoSolicitante),
      expression: "solicitacao.FgtsDoSolicitante"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input destacar-campos",
    attrs: {
      "id": "valor-do-fgts",
      "type": "text",
      "placeholder": "10.000,00"
    },
    domProps: {
      "value": (_vm.solicitacao.FgtsDoSolicitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "FgtsDoSolicitante", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('router-link', {
    staticClass: "botao botao_cinza botao_medio",
    class: {
      'is-disabled': _vm.loading.visivel
    },
    attrs: {
      "to": "/consulta-por-cpf"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cor-terciaria u-margem-esquerda-media",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.estaEmProcessoDeCadastroDaSolicitacao ||
        !_vm.solicitacao.SubsidioDaAgehab
    }
  }, [_vm._v("\n          Solicitar subsídio\n        ")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('i', {
    staticClass: "fal fa-user"
  }), _vm._v(" Pessoas")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mensagem mensagem_cor-atencao",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "far fa-exclamation-circle mensagem__icone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mensagem__conteudo"
  }, [_c('h2', {
    staticClass: "mensagem__titulo"
  }, [_vm._v("Atenção:")]), _vm._v(" "), _c('p', {
    staticClass: "mensagem__texto"
  }, [_vm._v("\n              Ao conferir a renda do proponente, verifique se é a mesma\n              cadastrada. Em caso de divergência atualize a renda no campo\n              \"Renda familiar comprovada\".\n              "), _c('strong', [_vm._v("A irregularidade dessa informação pode levar o processo ao\n                indeferimento")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('i', {
    staticClass: "fal fa-home"
  }), _vm._v(" Empreendimento\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "complemento"
    }
  }, [_vm._v("Complemento "), _c('span', [_vm._v("(Preenchimento é opcional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('i', {
    staticClass: "fal fa-sack-dollar"
  }), _vm._v(" Dados do financiamento\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-da-compra-e-venda"
    }
  }, [_vm._v("\n                Valor de Comercialização\n                "), _c('span', {
    staticClass: "tooltips"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "id": "tooltipValorDoFinanciamento",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "conteudo tooltip-top"
  }, [_vm._v("O valor de comercialização, é o total da soma de todos os\n                    campos em destaque.\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha"
  }, [_c('p', [_c('strong', [_vm._v(" Recursos Próprios ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-do-fgts"
    }
  }, [_vm._v("Valor do FGTS do proponente\n              "), _c('span', [_vm._v("(Preenchimento da informação é opcional)")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11aec689", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11aec689"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacao-de-subsidio/FormularioDeSolicitacao.vue
// module id = 1093
// module chunks = 1